import { ChangeDetectorRef, Component, ViewChildren, QueryList } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { SpeedReadingResultFigureComponent } from '../speed-reading-result-figure/speed-reading-result-figure.component';

@Component({
    selector: 'ms-speed-reading-result-block',
    templateUrl: './speed-reading-result-block.component.html',
    styleUrls: ['./speed-reading-result-block.component.scss'],
    hostDirectives: [DimensionsListenerDirective],
    standalone: false
})
export class SpeedReadingResultBlockComponent {
  wrapperStyles: Partial<CSSStyleDeclaration> = {};

  constructor(
    private readonly _dimensionsListener: DimensionsListenerDirective,
    private readonly _cdr: ChangeDetectorRef,
  ) {
    this._dimensionsListener.sizeChanges.subscribe((res) => {
      this.adjust(res.width, res.height);
    });
  }

  adjust(width: number, height: number) {
    this.wrapperStyles = {
      fontSize: Math.min(1.3, Math.min(width * 0.004, height * 0.008)) + 'px',
    };
  }
}
